export default "__VITE_ASSET__B0Q$pMvi__"